import { useEffect, useState } from "react";
import FormComp from "../../../Componentes/FormComp";
import Overlay from "../../../Componentes/Overlay";
import Formulario from "../../../Componentes/Utils/Formulario";
import Modal from "../../../Componentes/Utils/Modal";
import MultiFileUploader from "../../../Componentes/Utils/MultiFileUploader";

import { formatBRLFromCents, parseCentsFromInput } from "../../../Funcoes/Money";
import { useNavigate } from "react-router-dom";
import { useModal } from "../../../contexts/ModalContext";
import styled from "styled-components";
import useApi from "../../../hooks/useApi";

const ContainerFiles = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 18px;
`

const ModalNovoBM = ({ pedidoCompra, fecharModal }) => {

    const navigate = useNavigate();
    const { closeModal } = useModal();

    const api = useApi();

    const fetchInfo = async () => {

        try {

            const { data } = await api.get("/Painel/API/ControleMedicao/PedidoInfo/index.php?id=" + pedidoCompra.id);
            console.log(data);
            setFormValues((prevValues) => ({
                ...prevValues,
                nomeObra: data.pedido_compra ? data.pedido_compra.descricao_obra : "",
                numMedicao: data.pedido_compra ? data.pedido_compra.num_medicao + 1 : 1
            }))

        } catch (error) {

            console.error(error);

        }

    }

    const [formValues, setFormValues] = useState({
        nomeObra: "",
        idPc: pedidoCompra.id,
        numMedicao: 0,
        dataMedicao: new Date().toISOString().split("T")[0],
        valor: 0,
        fsr: "",
        observacoes: ""
    });

    useEffect(() => {
        fetchInfo();
    }, [])

    const [arquivos, setArquivos] = useState([]);

    const handleChange = (e) => {

        const { name, value } = e.target;

        setFormValues((prevValues) => {
            if (name === "valor") {
                return { ...prevValues, [name]: parseCentsFromInput(value) }
            }
            return { ...prevValues, [name]: value.toUpperCase() }
        })

    }

    const handleSubmit = async (e) => {

        e.preventDefault();
        closeModal();
        navigate(`/modulo/controle-medicao/pedidos-compra/${pedidoCompra.id}/previsao-boletim`,
            {
                state: {
                    pendingBM: formValues,
                    arquivos: arquivos
                }
            }
        );

    }

    return (
        <>
            <Overlay state={true} >
                <Modal header close={fecharModal} >
                    <Formulario onSubmit={handleSubmit}>
                        <FormComp
                            title="OBRA"
                            type="text"
                            readOnly={true}
                            valor={formValues.nomeObra}
                        />
                        <FormComp
                            title="CONTRATO"
                            type="text"
                            readOnly={true}
                            valor={pedidoCompra.nome_projeto}
                        />
                        <FormComp
                            title="PEDIDO DE COMPRA"
                            type="text"
                            readOnly={true}
                            valor={pedidoCompra.num_pedido}
                        />
                        <FormComp
                            title="Nº MEDIÇÃO"
                            type="text"
                            readOnly={true}
                            valor={formValues.numMedicao}
                        />
                        <FormComp
                            title="DATA MEDIÇÃO"
                            type="date"
                            valor={formValues.dataMedicao}
                            changeFunc={handleChange}
                            name="dataMedicao"
                        />
                        <FormComp
                            title="VALOR"
                            type="text"
                            inputMode="numeric"
                            valor={formatBRLFromCents(formValues.valor)}
                            name="valor"
                            changeFunc={handleChange}
                        />
                        <FormComp
                            title="FSR"
                            type="text"
                            valor={formValues.fsr}
                            name="fsr"
                            changeFunc={handleChange}
                        />
                        <FormComp
                            title="OBSERVAÇÕES"
                            type="textarea"
                            valor={formValues.observacoes}
                            name="observacoes"
                            changeFunc={handleChange}
                        />
                        <ContainerFiles>
                            <MultiFileUploader
                                files={arquivos}
                                setFiles={setArquivos}
                            />
                        </ContainerFiles>
                        <FormComp
                            valor="SALVAR"
                            type="submit"
                        />
                    </Formulario>
                </Modal>
            </Overlay>
        </>
    )
}

export default ModalNovoBM;